<template>
  <div class="branditem" :class="{itemright:branditemright,'brandleft':brandLeft}">
      <router-link v-if="brand.id==1" :to="{ name: 'brand', params: { id: brand.id }}">

          <img :src="brand.image" />
      </router-link>
      <router-link v-else :to="{ name: 'brandinfo', params: { id: brand.id }}" >

          <img :src="brand.image" />
      </router-link>
  </div>
</template>

<script>
export default {
    props:['brand','branditemright','brandLeft']
}
</script>

<style>


   
    .branditem {
         width: 183px;
         height: 150px;
         margin-right: 20px;
         float: left;
         border-radius: 5px;
         overflow: hidden;
         margin-top: 20px;
    }
    .branditem img{
        width: 100%;
        height: 150px;
        font-size: 0;
        background-color: #fff;
       
    }
    .itemright{
         margin-right: 0;
    }
    .branditem:last-child{
        margin-bottom: 145px;
    }
    .brandleft{
        margin-left: 108px;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsBrandItem.vue